<template>
    <div v-if="info.length != 0">


        <div class="splash__players__images" :class="{ reverse: reverse }">
            <div class="MatchDetailFigure__team">
                    <player-figure :player="info.stat.idA" :assoc="assoc"></player-figure>
                    <player-figure v-if="info.stat.idA2.length > 0":player="info.stat.idA2" :assoc="assoc"></player-figure>
                </div>

            <div class="generic-small vs-caption">
               {{ relation }}
            </div>
            <div class="MatchDetailFigure__team">
                    <player-figure :player="info.stat.idB" :assoc="assoc"></player-figure>
                    <player-figure v-if="info.stat.idB2.length > 0" :player="info.stat.idB2" :assoc="assoc"></player-figure>
            </div>
        </div>

        <div class="splash__state footer__social__caption generic-small">
            {{matchStatus()}}
        </div>


        <div class="splash__players__names" :class="{ reverse: reverse }">

            <div class="splash__players__team">

                <div class="splash__player__name" :class="{ double: info.stat.isDoubles == '1' }">

                    <h2>{{initial(info.stat.nAF)}}&nbsp;{{info.stat.nAL}}</h2>
                    <img class="small-flag" :src="flagPath + info.stat.cA.toLowerCase() + '.svg'"  :alt="info.stat.cA">

                </div>

                <div class="splash__player__name" :class="{ double: info.stat.isDoubles == '1'}" v-if="info.stat.isDoubles == '1'" >

                    <h2>{{initial(info.stat.nA2F)}}&nbsp;{{info.stat.nA2L}}</h2>
                    <img class="small-flag" :src="flagPath + info.stat.cA2.toLowerCase() + '.svg'" :alt="info.stat.cA2">

                </div>

            </div>

            <h5>{{ longRelation }}</h5>

            <div class="splash__players__team">

                <div class="splash__player__name" :class="{ double: info.stat.isDoubles == '1'}">

                    <h2>{{initial(info.stat.nBF)}}&nbsp;{{info.stat.nBL}}</h2>
                    <img class="small-flag" :src="flagPath + info.stat.cB.toLowerCase() + '.svg'" :alt="info.stat.cB">

                </div>

                <div class="splash__player__name" :class="{ double: info.stat.isDoubles == '1'}" v-if="info.stat.isDoubles == '1'" >

                    <h2>{{initial(info.stat.nB2F)}}&nbsp;{{info.stat.nB2L}}</h2>
                    <img class="small-flag" :src="flagPath + info.stat.cB2.toLowerCase() + '.svg'" :alt="info.stat.cB2">

                </div>
            </div>
        </div>

        <div class="splash__caption">

            <div class="splash__date" v-if="state == 'upcoming'">
                {{ date }}
            </div>

            <div class="splash__time" v-if="(state == 'upcoming' && time != '')">
                {{ time }}
            </div>

            <div class="splash__court">
                {{round}} - {{stadium}}
            </div>


        </div>
        <div class="splash__actions">
            <div class="splash__action" v-if="state == 'upcoming'">
                <a :href='ticket_link' class="general-button white-background generic-medium">
                    <span>GET TICKETS</span>
                </a>
            </div>
            <div class="splash__action" v-if="state == 'upcoming' && preview_btn">
                <a :href='preview_btn.url' class="general-button transparent-background generic-medium">
                    <span>{{preview_btn.title}}</span>
                </a>
            </div>
            <div class="splash__action" v-if="state == 'live'">
                <a :href='scores_link' class="general-button white-background generic-medium">
                    <span>LIVE SCORES</span>
                </a>
            </div>
            <div class="splash__action" v-if="state == 'completed'">
                <a :href='match_link + "?match=" + match' class="general-button white-background generic-medium">
                    <span>MATCH STATS</span>
                </a>
            </div>
            <div class="splash__action" v-if="state == 'completed' && recap_btn">
                <a :href='recap_btn.url' class="general-button transparent-background generic-medium">
                    <span>{{recap_btn.title}}</span>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import MatchDetailFigure from './MatchDetailFigure'
    import PlayerName from './PlayerName'

    export default {
        components: {
            'player-figure': MatchDetailFigure,
            'player-name': PlayerName
        },
        props: ['match', 'assoc', 'flag', 'date', 'time', 'stadium', 'round', 'match_link', "ticket_link", 'scores_link', 'recap', 'preview'],
        data() {
            return {
                info: [],
                setInfo: [],
                feed: [],
                news: [],
                preview_btn: JSON.parse(this.preview),
                recap_btn: JSON.parse(this.recap),
                ico_winner: window.ico_tick,
                ico_pointer_right: window.ico_pointer_right,
                ico_ball: window.ico_ball,
                ico_clock: window.ico_clock,
                ico_external: window.ico_external,
                ico_gallery: window.ico_gallery,
                ico_video: window.ico_video,
                formattedDate: "",
                flagPath: this.flag + '/assets/dist/svg/flags/'
            }
        },
        created() {
            this.getFeed()

            let app = this
            setInterval(function () {
                app.getFeed()
            }, 15 * 1000, app)
        },
        computed: {
            reverse(){

                if ( this.info.stat.winner == '3' || this.info.stat.winner == '5' || this.info.stat.winner == this.info.stat.idB) {
                    return true
                }

                return false
            },
            relation() {
                if (this.info.stat.state == 'F') {
                    return 'def.'
                }
                return 'vs.'
            },
            longRelation() {
                if (this.info.stat.state == 'F') {
                    return 'defeats'
                }
                return 'vs.'
            },
            state(){
                if(this.info.stat.state == '' || !this.info.stat.state){
                    return 'upcoming'
                }
                if (this.info.stat.state == 'F' || this.info.stat.state == 'S') {
                    return 'completed'
                }
                return 'live'
            }

        },
        methods: {


            transformDate(time) {
                const dateObj = new Date(time);

                const options = { year: 'numeric', month: 'short', day: 'numeric' };
                const formattedDate = dateObj.toLocaleDateString('en-US', options);

                return formattedDate;
            },

            matchStatus() {
                // console.log(this.info.stat)

                if(this.info.stat.state == '' || !this.info.stat.state ){
                    return 'Upcoming'
                }

                if (this.info.stat.state == 'F') {
                    return 'Completed'
                }

                if (this.info.stat.state == 'P') {
                    return 'Live Now'
                }

                if (this.info.stat.state == 'M') {
                    return 'In Progress'
                }

                if (this.info.stat.state == 'W') {
                    return 'Warmup'
                }

                if (this.info.stat.state == 'C') {
                    return 'On court'
                }

                if (this.info.stat.state == 'S') {
                    return 'Suspended'
                }

                if (this.info.state == 'G') {
                    return 'Players Arrived'
                }

                if (this.info.state == 'T') {
                    return 'Time Announcement'
                }

                return this.info.stat.state
            },

            getFeed() {

                axios.get(`${window.feed_ip}/get/${this.assoc}/${window.tournament}/${this.match}`).then(response => {

                    this.feed = response.data
                    this.info = response.data

                    if(this.info.stat.isDoubles == "" && ((this.feed.id && this.feed.id.substring(0, 2) == "LD" ) || (this.feed.stat.id && this.feed.stat.id.substring(0, 2) == "MD" )) ){
                        this.info.stat.isDoubles = 1;
                    }

                    // Would be nice to refactor this… nevertheless it works
                    let setInfo = []

                    if (response.data.length != 0) {
                        setInfo.push(...response.data.s1)
                        setInfo.push(...response.data.s2)
                        setInfo.push(...response.data.s3)

                        for (let sv in setInfo[2]) {

                            setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[2][sv])

                        }

                        for (let sv in setInfo[3]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[3][sv])

                        }

                        if (setInfo[4]) {

                            for (let sv in setInfo[4]) {

                                setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[4][sv])

                            }

                        }

                        for (let sv in setInfo[5]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[5][sv])

                        }

                        this.setInfo = setInfo
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },
            initial(name) {
                return `${name.charAt(0)}.`
            }
        }
    }
</script>
